import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  constructor(
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.validationSubscribe();
    this.redirection();
  }

  private validationSubscribe(): void {
    const idUserConfirm = parseInt(this.route.snapshot.queryParams.id, 10);
    const tokenUserConfirm = this.route.snapshot.queryParams.token;

    const userConfirm = {
      id: idUserConfirm,
      token: tokenUserConfirm
    };
    this.userService.validationSubscribe(userConfirm).subscribe(() => { });
  }

  private redirection(): void {
    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 6000);
  }


}
